
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Subject} from 'rxjs';
import { SharedService } from '@app/services/shared.service';
import {StorePagedResponse} from '@app/marketplace/stores/_models/store.interface';
import {CategoryPagedResponse, CategoryTreeResponse} from '@app/marketplace/categories/_models/category.interface';
import {SortDirection} from '@app/directives/sortable.directive';
import {debounceTime, delay, switchMap} from 'rxjs/operators';
interface State {
  page: number;
  pageSize: number;
  sortColumn: string;
  sortDirection: SortDirection;
}
function compare(v1, v2) {
  return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
}

function sort(countries: any[], column: string, direction: string): any[] {
  if (direction === '') {
    return countries;
  } else {
    return [...countries].sort((a, b) => {
      const res = compare(a[column], b[column]);
      return direction === 'ASC' ? res : -res;
    });
  }
}
@Injectable({
  providedIn: 'root'
})
export class CategoryService extends SharedService {

  private _total$ = new BehaviorSubject<number>(0);

  private _state: State = {
    page: 1,
    pageSize: 6,
    sortColumn: '',
    sortDirection: ''
  };

  flashOfferSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  flashOffer$ = this.flashOfferSubject.asObservable();

  constructor(
    httpCLient: HttpClient
  ) {
    super(httpCLient);
  }

  get total$() { return this._total$.asObservable(); }
  get page() { return this._state.page; }
  get pageSize() { return this._state.pageSize; }
  get state() { return this._state; }

  set page(page: number) { this._set({ page }); }
  set pageSize(pageSize: number) { this._set({ pageSize }); }
  set sortColumn(sortColumn: string) { this._set({ sortColumn }); }
  set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }
  set state(state: State) { this._set(state); }

  private _set(patch: Partial<State>) {
    Object.assign(this._state, patch);
  }

  ListCategories(payload: any) {
    const url = 'api/market/category/search';
    return this.post<CategoryPagedResponse>(url, payload);
  }

  GetCategoryTree() {
    const url = 'api/market/category/tree';
    return this.get<CategoryTreeResponse>(url);
  }

}
